<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <card>
            <template slot="header">
              <h4 class="card-title"><i class="icon-svg icon-file-text"></i>{{ $t("Documentos") }}</h4>
              <!--<button @click="addPathtoDB()" v-if="user.rol_id == 1">{{user.name}}</button>-->
            </template>
            <div class="documentList">
              <!-- Selection bar, the same one the file explorer uses: the counter
                   clears the selection and deleting is the only action this
                   listing offers. It belongs beside the search box, but that row
                   is markup DataTables builds for itself, so the bar is rendered
                   here and moved into it by mountSelectionBar(). The wrapper is
                   always in the DOM and only its content is conditional: Vue must
                   never have to re-insert an element whose position it no longer
                   owns. -->
              <div ref="selectionBar" class="cd-command-bar cd-table-selection">
                <template v-if="checkedItems.length > 0">
                  <button @click="onUnSelectAll" type="button"
                          class="cd-command-count" :title="$t('unselect_all')">
                    {{ checkedItems.length }} {{ $tc("selected_count", checkedItems.length) }}
                    <i class="fas fa-times ml-2"></i>
                  </button>
                  <button @click="onDeleteAllFile" type="button" class="btn cd-command-btn">
                    <i class="fas fa-trash mr-1"></i>
                    {{$t("Eliminar")}}
                  </button>
                </template>
              </div>
              <l-table
                  ref="table"
                  class="table-hover table-striped"
                :columns="columnsUser"
                :section="section"
                :urlDownload="urlDownload"
                @onCheckItem="onCheckItem"
                :data="tableData">
              </l-table>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiCallList, dataTableLengthMenu, dataTableEsLanguage, enhanceDataTableLength } from "../../mixins";
import {mapGetters} from "vuex";
import moment from "moment/moment";

export default
{
  computed: {
    ...mapGetters({
      user: 'login/user',
    })
  },
  mixins: [apiCallList],
  data ()
  {
    return {
      endpoint: "client_documents",
      section: "/admin/documentos",
      urlDownload: "/document/download/",
      columnsUser: ["check_all", "file_type", "file_name", "size", "user", "updated_at","path", "view_download"],
      showList : true,
      tableData: [],
      filter: "",
      dataTable: null,
      statusFilter: "all",
      checkedItems: [],
      // Folders the user can reach, indexed by id, to walk the path of a document.
      folders: {},
      CheckedTypes: [],
      validItem : {},
      statusValid : false
    }
  },
  methods:
  {
    onDeleteAllFile() {
    },
    // The row selection lives inside the table, so clearing it has to go through it.
    onUnSelectAll () {
      this.$refs.table.clearSelection ();
    },
    loadItems ()
    {
      // The rows wait for the folder tree: the path of each document is rebuilt from
      // it, because the folder_code stored with the document is written once when it
      // is uploaded and does not follow later moves or folder renames.
      this.onLoadFolders ().then (() => {
        this.data.forEach ((element) => {
          element.user = element.user ? element.user.name : "";
          element.file_name = element.name;
          element.download_file = element.url;
          element.path = this.onBuildPath (element.parent_id);
        });
        this.tableData = this.data;
        this.LoadDataTable ();
      });
    },
    // Every folder below the ones assigned to the user, which is all the listing can
    // show. Those roots come back with parent_id 0, so a path stops there.
    onLoadFolders ()
    {
      return this.$axios ("/client/folders")
        .then ((response) => {
          this.folders = {};
          (response.data || []).forEach ((folder) => {
            this.folders [folder.id] = folder;
          });
        })
        .catch (() => {
          this.folders = {};
        });
    },
    // Path of a document, walked up from the folder holding it. Null when the tree
    // does not reach that folder, and the table then falls back to folder_code.
    onBuildPath (parentId)
    {
      const names = [];
      let folder = this.folders [parentId];
      // Bounded by the number of known folders, so a cycle in the data cannot hang
      // the listing.
      let remaining = Object.keys (this.folders).length + 1;

      while (folder && remaining-- > 0)
      {
        names.unshift (folder.name);
        folder = folder.parent_id ? this.folders [folder.parent_id] : null;
      }

      return names.length ? "/ " + names.join (" / ") : null;
    },
    LoadDataTable ()
    {
      setTimeout (() => {
        this.dataTable = window.$(".table").dataTable ({
          autoWidth: false,
          dom: "lBfrtip",
          buttons: [
              /*{
              text: 'Delete',
              action: function (e) {
                console.log("delete");
                console.log(e);
              }
            },*/
            {
              extend: "excelHtml5",
              title: "Documentos",
              text: '<i class="icon-svg icon-file-excel"></i><span class="btn-label">Excel</span>',
              attr: { "data-tooltip": "Excel" },
              exportOptions: {
                columns: [1, 2, 3, 4, 5, 6],
              }
            },
            {
              extend: "pdfHtml5",
              text: '<i class="icon-svg icon-file-pdf"></i><span class="btn-label">PDF</span>',
              attr: { "data-tooltip": "PDF" },
              orientation: "landscape",
              title: "Documentos",
              exportOptions: {
                columns: [1, 2, 3, 4, 5, 6],
              },
              customize: function (doc)
              {
                doc.content [1].table.widths = "*";
                doc.styles.tableHeader.alignment = "center";
              }
            },
            {
              extend: "print",
              title: "Documentos",
              text: '<i class="icon-svg icon-printer"></i><span class="btn-label">Imprimir</span>',
              attr: { "data-tooltip": "Imprimir" },
              exportOptions: {
                columns: [1, 2, 3, 4, 5, 6],
              }
            }
          ],
          pagingType: "full_numbers",
          pageLength: 10,
          lengthMenu: dataTableLengthMenu,
          language: dataTableEsLanguage,
          columnDefs: [{ orderable: false, targets: -1 }]
        });
        enhanceDataTableLength();
        this.mountSelectionBar ();
      }, 100);
    },
    // DataTables builds the row that holds the length selector, the export
    // buttons and the search box, so Vue cannot render into it. The selection
    // bar is rendered next to the table and moved here once that row exists.
    // It goes after the search box in the DOM on purpose: everything in that
    // row is floated, and with float:right the first element is the one that
    // ends up furthest right, so this order leaves the search box against the
    // edge and the bar to its left.
    mountSelectionBar ()
    {
      const bar = this.$refs.selectionBar;
      const filter = this.$el.querySelector (".dataTables_filter");

      if (!bar || !filter || filter.nextElementSibling === bar) return;

      filter.parentNode.insertBefore (bar, filter.nextElementSibling);
    },
    onValidItem (type_id)
    {
      if (this.CheckedTypes.includes (type_id)) this.validItem [type_id] = {status : true}
      else if (!this.validItem [type_id]) this.validItem [type_id] = {status : this.statusValid}
      if (!this.CheckedTypes.includes (type_id)) this.statusValid = true;
      return this.validItem [type_id].status;
    },
    addPathtoDB()
    {
      this.$store.dispatch ("isLoadingOn");
      this.$axios ("/document/adding_paths")
        .then ((response) => {
          this.data = response.data;
          this.$store.dispatch ("isLoadingOff");
        })
        .catch(() => {
          this.$store.dispatch ("isLoadingOff");
        });

    },

    formatDate: function(dt){
      var d1 = new Date(dt);
      return d1;

    },
    formatDate3: function(dt){
      return dt != null ? moment(dt, "DD.MM.YYYY").format("DD/MM/YYYY") : null;
      //return dt != null ? moment(dt, 'DD/MM/YY HH:mm:ss').format('DD/MM/YYYY') : null;

    },

    onSearchFilter ()
    {
      this.$store.dispatch ("isLoadingOn");
      this.dataTable.fnDestroy ();
      this.$axios ("/client_documents")
        .then ((response) => {
          this.data = response.data;
          this.data.forEach ((element) => {
            element.file_name = element.name;
            element.download_file = element.url;
          });
          this.tableData = this.data;
          this.LoadDataTable ();     
          this.$store.dispatch ("isLoadingOff");
        })
        .catch(() => {
          this.$store.dispatch ("isLoadingOff");
        });
    },
    onSearch ()
    {
      this.dataTable.fnFilter (this.filter);
    },
    onCheckItem (items)
    {
      this.checkedItems = items;
    },
    loadTemplateDocumentation ()
    {
      this.$axios ("/template_request_documentation").then ((response) => {
        this.templates = response.data;
      });
    },
    convertCurrency (amount)
    {
      return new Intl.NumberFormat ('de-DE', { style: 'currency', currency: 'EUR' }).format (amount);
    }
  }
};
</script>

<style>
  fieldset[disabled]
  {
    background: #f7f7f7;
  }
  fieldset[disabled] .e-input
  {
    background: #f8f8f8 !important;
  }
  .text-blue
  {
    color: #007bff !important;
  }
  .bg-gray
  {
    background: #f0f0f0;
  }
  .buttons
  {
    margin-top: 35px;
  }
  .ghost
  {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .titleColor
  {
    color: #6674c3;
  }
  .table > thead > tr > th
  {
    color: #535353;
    padding: 15px 10px;
  }
  .table.table thead
  {
    /*background: #c7e1f8;*/
    padding: 15px;
  }
  .documentList td:nth-child(2)
  {
    text-transform: uppercase;
  }
  .Filters .form-group
  {
    margin-bottom: 0px;
  }
  .e-input[disabled]
  {
    background: #f8f8f8 !important;
  }
  .rotate90
  {
    transform: rotate(90deg);
    width: 60px;
    padding: 0;
    margin: 0;
    position: absolute;
    left: 2px;
    top: 70px;
  }
  .step-circle
  {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>